export const parseMetricNumber = (value?: any): number => {
  return typeof value === 'number' ? value : Number.parseFloat(value);
};

export const getFirstFiniteMetricValue = (record: IRecord | null | undefined, keys: string[]): number => {
  for (const key of keys) {
    const value = parseMetricNumber(record?.[key]);

    if (Number.isFinite(value)) {
      return value;
    }
  }

  return Number.NaN;
};
